export enum FormNames {
  survivor = 'Survivor',
  care_partner_edit = 'Care Partner Edit',
  care_partner_create = 'Care Partner Create',
}
